import React from 'react';

const SvgCheckEvolution = (props) => (
  <svg width={12} height={8} {...props}>
    <path
      fill="#6CC89F"
      fillRule="evenodd"
      stroke="#E2F4EC"
      strokeWidth={0.5}
      d="M10.88 1.34L4.54 8 1 4.272l1.213-1.235 2.346 2.471L9.787 0 11 1.278z"
    />
  </svg>
);

export default SvgCheckEvolution;
